import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetSubTitle } from "../../store/Subtitle/subTitleSlice";
import { approveSubTitle } from "../../thunks/subTitle/subTitle";
import { getFromLocal } from "../../utils/localStorage";
import { Modal } from "../common/modal";

const Header = () => {
  const dispatch = useDispatch();
  const { subTitleInfo, subTitle } = useSelector((state) => state.subTitle);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const approveSubTitleCb = () => {
    navigate("/tool/dashboard");
  };
  const onPreviewClick = () => {
    if (subTitle.length > 0) {
      dispatch(
        approveSubTitle(
          {
            video_id: subTitleInfo?.videoId,
            task_id: subTitleInfo?.taskId,
            file_id: subTitleInfo?.fileId,
            user_id: getFromLocal("userId"),
          },
          approveSubTitleCb
        )
      );
    } else {
      setShowModal(true);
    }
  };
  return (
    <>
      {showModal && (
        <Modal
          size="lg"
          center
          onClose={() => {
            setShowModal(false);
          }}
          open={showModal}
        >
          Please generate subtitle
        </Modal>
      )}
      <div className="bg-white px-4 py-2 shadow-md flex justify-between items-center z-[100]">
        <img
          className="w-10 cursor-pointer"
          src="/tool/dashboard/static/images/logo-192.png"
          alt="Logo"
          onClick={() => {
            dispatch(resetSubTitle());
            navigate("/");
          }}
        />
        <button
          title="Preview"
          // disabled={true}
          className="relative p-2 hover:bg-gray-100 rounded group"
          onClick={onPreviewClick}
        >
          <FontAwesomeIcon icon={faPlay} className="mr-2" />
          Generate
        </button>
      </div>
    </>
  );
};

export default Header;
